import capitalize from './capitalize';

export default capitalize;
